import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import { newUserMessages } from "./locales";
import { Translations } from "definitions/Locale";

i18n.use(LanguageDetector).init({
  // debug: false,
  defaultNS: "translations",
  fallbackLng: "pt",
  ns: ["translations"],
  resources: newUserMessages,
});

const translate = (sentenceKey: keyof Translations): string =>
  i18n.t(sentenceKey) as string;

export { i18n, translate };
